import http from "./http.js";
import serviceSaleOptions from "../helpers/serviceSaleOptions.js";

async function getService(id) {
  try {
    const response = await http.get(`services/${id}`);

    let saleOptions = "";
    for (const saleOption in serviceSaleOptions) {
      if (serviceSaleOptions[saleOption].value === response.data.saleOption) {
        saleOptions = saleOption;
      }
    }

    return {
      title: response.data.title,
      shortTitle: response.data.shortTitle,
      article: response.data.article,
      saleOptions,
      recurrence: {
        id: response.data.recurrence.id,
        title: response.data.recurrence.title,
      },
      amount: response.data.amount,
      amountWithVAT: response.data.amountWithVAT,
      comments: response.data.comments,
      purchasePrice: response.data.purchasePrice,
      accountAsCommodity: response.data.accountAsCommodity,
      type: response.data.serviceType
        ? {
          id: response.data.serviceType.id,
          title: response.data.serviceType.title,
        }
        : null,
      clients: response.data.clients,
    };
  } catch (err) {
    throw err;
  }
}

async function updateService(id, service) {
  try {
    const response = await http.put(`services/${id}`, service);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createService(service) {
  try {
    const response = await http.post("services", service);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getServices(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      "services", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
          serviceTypeId: filter?.serviceType?.id || "",
        },
      }
    );
    const result = response.data.result.map((s) => {
      return {
        accountAsCommodity: s.accountAsCommodity,
        amount: s.amount,
        amountWithVAT: s.amountWithVAT,
        comments: s.comments,
        id: s.id,
        recurrence: s.recurrence,
        serviceType: s.serviceType,
        title: s.shortTitle,
        shortTitle: s.shortTitle,
        article: s.article,
      };
    });
    return {
      currentPage: response.data.currentPage,
      itemsPerPage: response.data.itemsPerPage,
      result,
      totalItems: response.data.totalItems,
    };
  } catch (err) {
    throw err;
  }
}

async function selectService(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get("services/references", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function validateShortTitle(shortTitle) {
  try {
    const response = await http.get("services/check-existence", {
      params: {
        shortTitle,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getService,
  updateService,
  createService,
  selectService,
  getServices,
  validateShortTitle,
};
